export default __webpack_public_path__ + "static/media/Group 878.8ad817cf.jpg";